module.exports = __webpack_public_path__ + "img/job-creation.56ead14c.png";